import StarSharpIcon from 'components/common/icons/StarSharpIcon'

const TOTAL_STARS = 5

const StarRatingDisplay = ({ stars }: { stars: number }) => {
  const filledStars = Math.round(stars * 2) / 2

  return (
    <>
      <div aria-hidden="true" className="flex items-center gap-x-0.5">
        {Array.from({ length: TOTAL_STARS }, (_, index) => {
          const filledShare = Math.min(Math.max(filledStars - index, 0), 1)

          return (
            <span key={index} className="relative block h-4 w-4 text-grey-4">
              <StarSharpIcon />

              <span
                className="absolute inset-y-0 left-0 block overflow-hidden text-orange-1"
                style={{ width: `${filledShare * 100}%` }}
              >
                <span className="block h-4 w-4">
                  <StarSharpIcon />
                </span>
              </span>
            </span>
          )
        })}
      </div>

      <span className="sr-only">
        {stars} out of {TOTAL_STARS} stars
      </span>
    </>
  )
}

export default StarRatingDisplay
